import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { Country } from 'react-phone-number-input';
import { countryOptions } from 'domains/PhoneNumber';

type SelectCountryNumberProps = {
  countryCode: string;
  setCountryCode: (countryCode: Country) => void;
  className?: string;
};

export const SelectCountryNumber = ({
  countryCode,
  setCountryCode,
  className,
}: SelectCountryNumberProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (code: Country) => {
    setCountryCode(code);
    handleClose();
  };
  const selectedOption = countryOptions.find((option) => option.countryCode === countryCode);

  return (
    <div>
      <Button
        aria-controls="country-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className={className}
        style={{
          border: '1px solid var(--c-textinput-border)',
          borderRadius: '8px',
          height: '40px',
          padding: '0 10px',
          color: 'var(--c-textinput-text)',
          fontFamily: 'inherit',
          fontSize: 'inherit',
          whiteSpace: 'nowrap',
          display: 'flex',
          alignItems: 'center',
          width: '160px',
        }}
      >
        <span style={{ whiteSpace: 'nowrap' }}>{countryCode}</span>
        <span
          className={`${selectedOption?.flag} rounded-full ml-4`}
          style={{
            marginRight: '8px',
            width: '24px',
            height: '24px',
            display: 'inline-block',
            backgroundSize: 'cover',
            border: '2px solid var(--c-textinput-border)',
          }}
        ></span>
        {selectedOption?.value}
      </Button>
      <Menu id="country-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
        {countryOptions.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === countryCode}
            onClick={() => handleMenuItemClick(option.countryCode)}
            className={`flex items-center`}
          >
            {option.countryCode}
            <span
              className={`${option.flag} rounded-full ml-4`}
              style={{
                marginRight: '8px',
                width: '24px',
                height: '24px',
                display: 'inline-block',
                backgroundSize: 'cover',
              }}
            ></span>
            {option.value}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
